export const PaymentMethod = {
  PYPL: 'PYPL',
  BANKWIRE: 'BANKWIRE',
};
